import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPaintings } from '../store/actions/paintingsActions';
import PaintingList from '../components/Painting/PaintingList';
import usePageTitle from '../hooks/usePageTitle';

const Gallery = () => {
    const dispatch = useDispatch();
    const { paintings, loading, error } = useSelector(state => state.paintingsState);
    const [filter, setFilter] = useState('all');

    usePageTitle("Gallery | Dinara Fariz");

    useEffect(() => {
        dispatch(fetchPaintings());
    }, [dispatch]);

    const filteredPaintings = paintings.filter((painting) => {
        if (filter === 'all') return true;
        if (filter === 'available') return painting.published === true;
        if (filter === 'sold') return painting.published === false;
        return true;
    });

    if (loading) {
        return (
            <div className="text-center py-10 text-gray-500">
                Loading...
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center py-10 text-red-600">
                Error: {error}
            </div>
        );
    }

    return (
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-6 md:py-12">
            <div className="flex justify-center gap-4 md:gap-6 mb-8 text-[10px] md:text-xs uppercase tracking-[0.15em] md:tracking-[0.2em]">
                <button
                    onClick={() => setFilter('all')}
                    className={`pb-1 border-b transition ${
                        filter === 'all'
                            ? 'border-black text-black'
                            : 'border-transparent text-gray-400 hover:text-black'
                    }`}
                >
                    All
                </button>

                <button
                    onClick={() => setFilter('available')}
                    className={`pb-1 border-b transition ${
                        filter === 'available'
                            ? 'border-black text-black'
                            : 'border-transparent text-gray-400 hover:text-black'
                    }`}
                >
                    Available
                </button>

                <button
                    onClick={() => setFilter('sold')}
                    className={`pb-1 border-b transition ${
                        filter === 'sold'
                            ? 'border-black text-black'
                            : 'border-transparent text-gray-400 hover:text-black'
                    }`}
                >
                    Sold
                </button>
            </div>

            <PaintingList paintings={filteredPaintings} />
        </div>
    );
};

export default Gallery;